<template>
  <div class="border-t border-n-600">
    <div class="mx-4 py-3 text-n-0">
      <div class="flex justify-between items-center">
        <div>{{ t('checkout.charge-surcharge-to-tab') }}</div>
        <l-switch
          :model-value="isChecked"
          @update:model-value="e => toggleSurcharge(e as boolean)"
        />
      </div>
      <div
        v-if="isChecked && !!tab.terraceSurchargePercentage"
        class="flex justify-between items-center text-n-200 text-sm pt-1"
      >
        {{ t('checkout.terrace-surcharge') }}: +{{ tab.terraceSurchargePercentage }}%
        <div>{{ currency(surchargeAmountForPendingTotal) }}</div>
      </div>
      <div
        v-if="isChecked && !!tab.flatFeeSurcharge"
        class="flex justify-between items-center text-n-200 text-sm pt-1"
      >
        {{ t('checkout.flat-fee-surcharge') }}
        <div>+{{ currency(tab.flatFeeSurcharge) }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { LSwitch } from '@last/core-ui/paprika'

import { useMoney } from '@/composables/useMoney'
import { useTabs } from '@/composables/useTabs'

type Props = {
  tabId: string
}

const props = defineProps<Props>()

const emit = defineEmits<{
  toggle: [boolean]
}>()

const { t } = useI18n()
const { currency } = useMoney()
const { pendingBill, tab } = useTabs(() => props.tabId)

const isChecked = ref<boolean>(false)

const surchargeAmountForPendingTotal = computed(() => {
  return pendingBill.value?.terraceSurcharge || 0
})

onMounted(() => {
  isChecked.value = !!tab.value.terraceSurchargePercentage || !!tab.value.flatFeeSurcharge
})

function toggleSurcharge(value: boolean): void {
  isChecked.value = value
  emit('toggle', value)
}
</script>
